import {LABELS} from '@github-ui/item-picker-base/constants/labels'
import {SharedPicker} from '@github-ui/item-picker-base/SharedPicker'
import {MilestoneIcon} from '@primer/octicons-react'
import type {MilestonePickerBaseProps} from './MilestonePickerBase'

type DefaultMilestonePickerAnchorProps = Pick<MilestonePickerBaseProps, 'activeMilestone' | 'readonly' | 'nested'> & {
  anchorProps?: React.HTMLAttributes<HTMLElement> | undefined
} & {ref?: React.Ref<HTMLButtonElement>}

export const DefaultMilestonePickerAnchor = ({
  ref,
  activeMilestone,
  readonly,
  nested,
  anchorProps,
}: DefaultMilestonePickerAnchorProps) => {
  return (
    <SharedPicker
      anchorText={LABELS.noMilestones}
      sharedPickerMainValue={activeMilestone?.title}
      anchorProps={readonly ? undefined : anchorProps}
      ariaLabel={LABELS.selectMilestones}
      readonly={readonly}
      nested={nested}
      leadingIcon={MilestoneIcon}
      hotKey={undefined}
      ref={ref}
    />
  )
}

DefaultMilestonePickerAnchor.displayName = 'DefaultMilestonePickerAnchor'
